import { Link, Typography } from '@mui/material';
import { META } from 'common/constants';
import { FormCheckbox } from 'components/lib/FormCheckbox';
import { FormControl } from 'components/lib/FormControl';
import type { FormikProps } from 'formik';
import type { FC } from 'react';
import { PurchaseTypographyAgreementStyle } from 'routes/Purchase/Purchase.styles';
import CheckboxSectionCard from './CheckboxSectionCard';
import type { IPaymentFormikValues } from './CheckoutForm';

interface TermsAndConditionsProps {
  formik: FormikProps<IPaymentFormikValues>;
  isLoading: boolean;
  isAutopayRequired?: boolean;
}

const TermsAndConditions: FC<TermsAndConditionsProps> = ({
  formik,
  isLoading,
  isAutopayRequired = false,
}) => {
  const checkbox = (
    <FormCheckbox
      id="accept_terms_and_conditions"
      data-test="accept_terms_and_conditions"
      name="accept_terms_and_conditions"
      checked={formik.values.accept_terms_and_conditions}
      onChange={formik.handleChange}
      disabled={isLoading}
      labelText={
        <Typography variant="body2" sx={PurchaseTypographyAgreementStyle}>
          I agree that I am the applicant or an authorized representative of the applicant and
          represent that reasonable inquiry has been made to obtain the answers to the questions on
          this application. I agree that I fully read and understand{' '}
          <Link href={META.TERMS_CONDITIONS_LINK} target="_blank">
            the terms of this application.
          </Link>{' '}
          I certify and represent that the answers are true, correct and complete to the best of my
          knowledge. I agree to keep THREE informed of any business changes affecting the risk being
          underwritten, including but not limited to changes in location, services performed, or
          staffing, during the effective period of any insurance policy, including any renewals. I
          agree that failure to keep THREE informed may affect available coverage.
        </Typography>
      }
    />
  );

  return (
    <FormControl
      error={
        formik.touched.accept_terms_and_conditions &&
        Boolean(formik.errors.accept_terms_and_conditions)
      }
      errorMessage={String(formik.errors.accept_terms_and_conditions)}
      sx={{
        mb: 4,
      }}
    >
      {isAutopayRequired ? (
        <CheckboxSectionCard title="Acknowledgment">{checkbox}</CheckboxSectionCard>
      ) : (
        checkbox
      )}
    </FormControl>
  );
};

export default TermsAndConditions;
